var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSocialGmap(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1090_12498)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30365 16C9.88666 16 11.4341 15.5306 12.7504 14.6511C14.0666 13.7717 15.0925 12.5216 15.6982 11.0591C16.304 9.59659 16.4625 7.98728 16.1537 6.43469C15.8449 4.88209 15.0826 3.45595 13.9632 2.33659C12.8439 1.21723 11.4177 0.454935 9.86512 0.146105C8.31253 -0.162726 6.70322 -0.00422161 5.24071 0.601571C3.7782 1.20736 2.52817 2.23324 1.6487 3.54946C0.769222 4.86569 0.299805 6.41315 0.299805 7.99616C0.299805 10.1189 1.14307 12.1547 2.64408 13.6557C4.14509 15.1567 6.1809 16 8.30365 16Z",
    fill: "#299400"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30357 2.49963C11.0526 2.49963 12.9212 4.61758 12.9212 6.90022C12.9212 7.82374 12.7211 8.61797 12.2547 9.61691C9.52108 9.61691 9.02237 11.4347 8.90385 12.6507L8.82074 13.5003H7.78793L7.70481 12.6507C7.58784 11.4332 7.08914 9.61691 4.35397 9.61691C3.89221 8.61643 3.6875 7.81758 3.6875 6.90022C3.6875 4.61758 5.55455 2.49963 8.30511 2.49963H8.30357Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1090_12498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.299805)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialGmap);
export default __webpack_public_path__ + "static/media/social_gmap.f8e30924894b41aa0e9a5cfb30de2199.svg";
export { ForwardRef as ReactComponent };